import React from "react";
import { HomeEmptyStateTemplate } from "themes/application/home/components";

function HomeEmptyState(props) {
    return <HomeEmptyStateTemplate {...props} />;
}

export default HomeEmptyState;
